/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentTypesResponse as ModelsCustomerCustomerOnlinePaymentTypesResponse } from '../../models/Models/Customer/customer-online-payment-types-response';

export interface V3CustomersMeOnlinePaymentTypesGet$Plain$Params {
}

export function v3CustomersMeOnlinePaymentTypesGet$Plain(http: HttpClient, rootUrl: string, params?: V3CustomersMeOnlinePaymentTypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeOnlinePaymentTypesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>;
    })
  );
}

v3CustomersMeOnlinePaymentTypesGet$Plain.PATH = '/v3/customers/me/online-payment-types';
